import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer/lib/popSignUp";
export var SignUpButton = function(param) {
    var _param_primary = param.primary, primary = _param_primary === void 0 ? false : _param_primary, tmp = param["data-test-id"], dataTestId = tmp === void 0 ? "signUpButton" : tmp;
    var history = useHistory();
    var handleSignUp = function() {
        return popSignUp(history, SignUpType.FAIRE_DIRECT, function() {
            return null;
        }, {
            element: SignUpElement.HEADER,
            sourceId: "fd_landing_sign_up_button"
        });
    };
    return /*#__PURE__*/ _jsx(StyledButton, {
        onClick: handleSignUp,
        variant: primary ? "primary" : "secondary",
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "HdGwFF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Start Shopping"
                }
            ]
        })
    });
};
var StyledButton = styled(Button).withConfig({
    componentId: "sc-6e5fa281-0"
})([
    "width:fit-content;min-width:200px;"
]);
